module.exports = __webpack_public_path__ + "media/images/cplook/android-chrome-72x72-bd3969d39fc8fbf2278d2b1793789b2a.png";